<template>
  <ElectronicInvoice />
</template>
<script>
export default {
  name: 'electronicInvoice'
}
</script>
